import { BrowserRouter as Router } from "react-router-dom";
import Header from "./pages/header";
import Footer from "./pages/footer";
import Routes from "./routes";
import Theme from "./theme";

function App() {
  return (
    <Theme>
      <Router>
        <Header />
        <Routes />
        <Footer />
      </Router>
    </Theme>
  );
}

export default App;
